export const GET_ACCOUNTS = "get-accounts";
export const GET_ACCOUNTS_CATEGORIZE = "get-accounts-categorize";
export const GET_BANK_CONNECTIONS = "get-bank-connections";
export const GET_BANK_CONNECTION = "get-bank-connection";
export const GET_REMOTE_ACCOUNTS = "get-remote-accounts";
export const MY_DEPOTS = "my-depots";
export const MY_INVOICES = "my-invoices";
export const GET_INDUSTRIES_KEY = "get-industries";
export const LOAD_FUND_BY_ISIN = "load_fund_by_isin";
export const GET_HISTORIC_QUOTES = "get-historic-quotes";
export const GET_HISTORIC_QUOTES_LOOKUP = "get-historic-quotes-lookup";
export const GET_SUBSCRIPTIONS = "get-subscriptions";
export const GET_ACCOUNT_HOLDERS = "get-account-holders";
export const GET_REALIZED_GAINS = "get-realized-gains";
export const GET_SPLIT_KEY = "get-split";
export const GET_SPLITS_KEY = "get-splits";
export const GET_DIVIDENDS_MASTER_KEY = "get-dividends-master";
export const GET_DIVIDEND_MASTER_KEY = "get-dividend-master";
export const GET_USER_PROFILE_KEY = "get-user-profile";
export const GET_USER_PROFILE_SUBSCRIPTION_KEY =
  "get-user-profile-subscription";
export const GET_FUND_COMMISITIONS_KEY = "get-fund-commissions";

export const ACCOUNT = "account";

export const ACCOUNT_PERFORMANCE_BY_ASSET_TYPES =
  "account-performance-by-asset-types";
export const ACCOUNT_PERFORMANCE_BY_ACCOUNT_IDS =
  "account-performance-by-account-ids";

export const TRANSACTIONS = "transactions";
export const HISTORIC_QUOTES = "historic-quotes";

export const INVESTMENT_PERFORMANCE = "investment-performance";
export const GET_NEWS_FEED = "get-news-feed";
export const GET_NEWS_FEED_RENTABLO_BLOG = "get-news-feed-rentablo-blog";

export const GET_USER_PROFILE_IMAGE = "get-user-profile-image";
export const GET_DIVIDENDS_CALENDAR = "get-dividends-calendar";
export const GET_DIVIDENDS_PORTFOLIO_YIELD = "get-dividends-portfolio-yield";
export const GET_DIVIDENDS_HISTORY = "get-dividends-history";
export const GET_DIVIDENDS_PREDICTION = "get-dividends-prediction";
export const GET_AND_VALIDATE_FINANZFLUSS_BOOKINGS_KEY =
  "get-and-validate-finanzfluss-bookings";
